import React from 'react';
import stoneco from '../../../images/Footer/stoneco.svg';
import stone from '../../../images/Footer/stone.svg';
import ton from '../../../images/Footer/ton.svg';
import pagarme from '../../../images/Footer/pagarme.svg';

import { Link } from '../../Link';

import * as S from './styles';
import LazyImage from '@/components/LazyLoadImage';

export const StoneCompanies = () => {
  return (
    <>
      <S.StoneCoBottomLink>
        <Link target="_blank" rel="noreferer noopener" to="https://www.stone.co/" aria-label="Stone co">
          <LazyImage style={{ width: 88 }} className="stoneco" src={stoneco} alt="Stone logo" />
        </Link>
      </S.StoneCoBottomLink>
      <S.Wrapper>
        <S.Container className="stone-container">
          <ul>
            <li className="selected">
              <Link target="_blank" rel="noreferer noopener" to="https://www.pagar.me/" aria-label="Pagar.me">
                <LazyImage src={pagarme} alt="Pagar.me logo" />
                <span className="logo-description">Pagar.me</span>
              </Link>
            </li>
            <li>
              <Link target="_blank" rel="noreferer noopener" to="https://www.stone.com.br/" aria-label="Stone">
                <LazyImage src={stone} alt="Stone logo" />
                <span className="logo-description">Stone</span>
              </Link>
            </li>
            <li>
              <Link target="_blank" rel="noreferer noopener" to="https://www.ton.com.br/" aria-label="Ton">
                <LazyImage src={ton} alt="Ton logo" />
                <span className="logo-description">Ton</span>
              </Link>
            </li>
          </ul>
        </S.Container>
      </S.Wrapper>
    </>
  );
};
